export const pattern19Data = [
  {
    koreanChunks: ["관리자는 (과거에)승인했다", "예산을", "어제"],
    englishChunks: ["The manager approved", "the budget", "yesterday"],
    fullEnglish: "The manager approved the budget yesterday.",
    additionalExplanation:
      "원어민들은 '누가 했는지'가 더 중요할 때 능동태를 사용합니다. 즉 여기선 매니저가 했다라는 행동 주체가 중요한 것이죠.",
  },
  {
    koreanChunks: ["팀이 (현재)일하는 중이다", "새 프로젝트에"],
    englishChunks: ["The team is working", "on the new project"],
    fullEnglish: "The team is working on the new project.",
    additionalExplanation:
      "이 문장은 능동태로, 행동의 주체인 '팀'이 직접 행동(일하는 것)을 수행하고 있음을 강조합니다. 원어민들은 행동의 주체와 그 행동이 모두 중요할 때 능동태를 사용합니다.",
  },
  {
    koreanChunks: ["우리는 (현재)완료했다", "시장 분석을"],
    englishChunks: ["We have completed", "the market analysis"],
    fullEnglish: "We have completed the market analysis.",
    additionalExplanation:
      "이 화자는 우리가 시장 분석을 완료했다라는 직접 한 행위를 강조하기 위해 능동태를 사용했습니다.",
  },
  {
    koreanChunks: ["우리는 (미래에)서명할 것이다 계약서에", "내일"],
    englishChunks: ["We will sign the contract", "tomorrow"],
    fullEnglish: "We will sign the contract tomorrow.",
    additionalExplanation:
      "'누가' 했는지 , 행동 주체, 행위를 강조할때 능동태를 사용합니다.",
  },
  {
    koreanChunks: ["예산이 (과거에)승인되었다", "관리자에 의해"],
    englishChunks: ["The budget was approved", "by the manager"],
    fullEnglish: "The budget was approved by the manager.",
    additionalExplanation:
      "원어민이 능동태를 안 쓰고 수동태를 쓰는 이유는 행위나 주체가 중요하기보단 결과나 대상이 더 중요해서 결과나 대상을 강조하고 싶을 때 사용합니다. 이 화자는 주체가 중요하지 않거나 이미 알고 있으며 승인된 사실이 더 중요해서 수동태를 사용했습니다.",
  },
  {
    koreanChunks: ["새 제품이 (과거에)출시되었다", "지난 주에"],
    englishChunks: ["A new product was launched", "last week"],
    fullEnglish: "A new product was launched last week.",
    additionalExplanation:
      "이 문장은 수동태로, '누가' 제품을 출시했는지보다 '제품이 출시되었다'는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다.",
  },
  {
    koreanChunks: ["보고서가 (과거에)제출되었다", "정오 전에"],
    englishChunks: ["The report was submitted", "before noon"],
    fullEnglish: "The report was submitted before noon.",
    additionalExplanation: "누가 냈는지가 중요한게 아니라 제출 완료가 포인트",
  },
  {
    koreanChunks: ["청구서가 (과거에) 발송되었다", "고객에게"],
    englishChunks: ["The invoice was sent", "to the client"],
    fullEnglish: "The invoice was sent to the client.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 청구서를 보냈는지보다 청구서가 고객에게 발송되었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다.",
  },
  {
    koreanChunks: ["문제가 (과거에) 해결되었다", "신속하게"],
    englishChunks: ["The issue was resolved", "quickly"],
    fullEnglish: "The issue was resolved quickly.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 문제를 해결했는지보다 문제가 해결되었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 문제 해결이라는 결과가 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["문서들이 (현재)검토된다", "매주 금요일마다"],
    englishChunks: ["The documents are reviewed", "every Friday"],
    fullEnglish: "The documents are reviewed every Friday.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 문서를 검토하는지보다 문서가 정기적으로 검토된다는 사실이 더 중요할 때 사용됩니다. ",
  },
  {
    koreanChunks: ["보고서가 준비되는 중이다", "비서에 의해"],
    englishChunks: ["The report is being prepared", "by the assistant"],
    fullEnglish: "The report is being prepared by the assistant.",
    additionalExplanation:
      "이 화자는 누가 보고서를 준비하는게 중요한게 안리ㅏ 보고서가 현재 준비되는 중임을 강조하고 싶어서, 보고서에 관심이 집중되어야 하기에 수동태를 사용했습니다.",
  },
  {
    koreanChunks: ["회의실이 (현재) 청소되는 중이다", "지금"],
    englishChunks: ["The conference room is being cleaned", "right now"],
    fullEnglish: "The conference room is being cleaned right now.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 회의실을 청소하는지보다 회의실이 현재 청소 중이라는 상태가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 상황이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 청소하는 사람보다 회의실의 상태가 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["물품들이 (현재) 포장되는 중이다", "배송을 위해"],
    englishChunks: ["The items are being packed", "for shipment"],
    fullEnglish: "The items are being packed for shipment.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 물품을 포장하는지보다 물품이 현재 배송을 위해 포장 중이라는 상태가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 상황이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 포장하는 사람보다 물품의 상태가 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["새로운 정책이 (현재) 시행되는 중이다", "모든 부서에 걸쳐"],
    englishChunks: [
      "A new policy is being implemented",
      "across all departments",
    ],
    fullEnglish: "A new policy is being implemented across all departments.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 정책을 시행하는지보다 정책이 현재 시행 중이라는 상태가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 상황이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 정책을 시행하는 주체보다 정책이 시행되고 있다는 사실이 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["패키지가 (현재)배달됬다", "당신의 사무실로"],
    englishChunks: ["The package has been delivered", "to your office"],
    fullEnglish: "The package has been delivered to your office.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 패키지를 배달했는지보다 패키지가 사무실에 배달되었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 배달 행위자보다 패키지가 배달되었다는 결과가 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["청구서가 (현재)보내졌다", "고객에게"],
    englishChunks: ["The invoice has been sent", "to the client"],
    fullEnglish: "The invoice has been sent to the client.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 청구서를 보냈는지보다 청구서가 고객에게 보내졌다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 보낸 사람보다 청구서가 보내졌다는 결과가 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["새 소프트웨어가 (현재)설치됬다", "성공적으로"],
    englishChunks: ["The new software has been installed", "successfully"],
    fullEnglish: "The new software has been installed successfully.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 소프트웨어를 설치했는지보다 소프트웨어가 성공적으로 설치되었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 설치한 사람보다 소프트웨어가 성공적으로 설치되었다는 결과가 중요하기 때문에 수동태가 사용되었습니다.",
  },

  {
    koreanChunks: ["변경사항들이 (현재)승인됬다", "매니저에 의해"],
    englishChunks: ["The changes have been approved", "by the manager"],
    fullEnglish: "The changes have been approved by the manager.",
    additionalExplanation:
      "이 문장은 수동태로, 변경사항이 승인되었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 '매니저에 의해'라는 행위자가 언급되었지만, 주된 초점은 변경사항이 승인되었다는 결과에 있습니다. 수동태를 통해 변경사항의 상태가 강조됩니다.",
  },
  {
    koreanChunks: [
      "파일들이 (과거에)복사되는 중이었다",
      "시스템이 (과거에)다운됐을 때",
    ],
    englishChunks: ["The files were being copied", "when the system crashed"],
    fullEnglish: "The files were being copied when the system crashed.",
    additionalExplanation:
      "누가 복사하는 중이었느냐가 아니라 파일이 복사되는 중이었다는 결과를 강조하고 싶을 때 사용합니다.",
  },
  {
    koreanChunks: ["방이 (과거에)장식되는 중이었다", "행사를 위해"],
    englishChunks: ["The room was being decorated", "for the event"],
    fullEnglish: "The room was being decorated for the event.",
    additionalExplanation:
      "이 문장은 수동태로, 누가 방을 장식했는지보다 방이 장식되고 있었다는 상태가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 상황이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 장식하는 사람보다 방이 장식되고 있었다는 과정이 중요하기 때문에 수동태가 사용되었습니다.",
  },
  {
    koreanChunks: ["장비가 (과거에)설치되었다", "팀이 (과거에)도착했을 때까지"],
    englishChunks: [
      "The equipment had been installed",
      "by the time the team arrived",
    ],
    fullEnglish:
      "The equipment had been installed by the time the team arrived.",
    additionalExplanation:
      "이 문장은 과거완료 수동태로, 누가 장비를 설치했는지보다 팀이 도착하기 전에 장비가 이미 설치되어 있었다는 결과가 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 또한 과거의 특정 시점(팀이 도착한 시점) 이전에 이미 완료된 행동을 표현하기 위해 과거완료 시제를 사용했습니다.",
  },
  {
    koreanChunks: ["계약서가 (미래에)서명될 것이다", "내일"],
    englishChunks: ["The contract will be signed", "tomorrow"],
    fullEnglish: "The contract will be signed tomorrow.",
    additionalExplanation:
      "이 문장은 미래 수동태로, 누가 계약서에 서명할 것인지보다 계약서가 내일 서명될 것이라는 사실이 더 중요할 때 사용됩니다. 원어민들은 행위자보다 행위의 대상이나 결과를 강조하고 싶을 때 수동태를 선택합니다. 여기서는 서명할 사람보다 계약서가 내일 서명될 것이라는 사실이 중요하기 때문에 수동태가 사용되었습니다.",
  },
];
